/* eslint-disable */
import { Box, Progress, Text } from "@chakra-ui/react";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AllCourses from "./AllCourses";
import SearchComponent from "../common/SearchComponent";
import { ReactComponent as CoursesIcon } from "../../svg/book.svg";
import EmptyComponentTemplate from "../common/EmptyComponentTemplate";
import MobileAllCourses from "./MobileAllCourses";
import { loadCourses } from "../../redux/api_calls/apiCalls";
import {
  resetAdvancedSearchParams,
  resetCourseView,
  resetIntegrityError,
  searchAutocompleteList,
  searchReset,
  selectedMenu,
  setCourseView,
  setHeaderAdvancedSearchParams,
  setHeaderButtonParams,
  setHeaderText,
} from "../../redux/actions/actions";
import AlertMessage from "../common/AlertMessage";
import CourseCalendar from "../Calendar/CourseCalendar";

export default function Courses() {
  const dispatch = useDispatch();
  const { coursesData, isLoading, /*coursesError,*/ integrityError } =
    useSelector((state) => state.coursesState);
  const headerText = useSelector((state) => state.headerState.headerText);
  const [loadMoreVisible, setLoadMoreVisible] = useState(true);
  const [visibleData, setVisibleData] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const finalSearch = useSelector((state) => state.searchState.finalSearch);
  const currentView = useSelector((state) => state.courseViewState);
  const advancedSearch = useSelector((state) => state.advancedSearchState);
  const slider = useSelector((state) => state.sliderState.sliderOpen);

  const loadAllCourses = () => {
    dispatch(loadCourses());
    console.log(coursesData);
  };

  const onAlertClose = () => {
    dispatch(resetIntegrityError());
  };

  useEffect(() => {
    dispatch(setHeaderText("Library"));
    dispatch(resetAdvancedSearchParams());
    dispatch(selectedMenu(1));
    if (!coursesData.length) {
      loadAllCourses();
    }
    dispatch(setCourseView(0));
    dispatch(
      setHeaderButtonParams({
        name: "Items",
        link: "/courses/add-items",
        bgColor: "#fd5f3a",
        hoverColor: "#e35533",
      })
    );
    dispatch(setHeaderAdvancedSearchParams(["Keywords", "Number of Topics"]));
    return () => {
      dispatch(searchReset());
      dispatch(resetCourseView());
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(searchAutocompleteList(coursesData.map((course) => course.title)));
    setVisibleData(coursesData.slice(0, 10));
    if (coursesData.length <= 10) {
      setLoadMoreVisible(false);
    } else {
      setLoadMoreVisible(true);
    }
    // eslint-disable-next-line
  }, [coursesData]);

  useEffect(() => {
    setAlertOpen(integrityError);
  }, [integrityError]);

  useEffect(() => {
    if (finalSearch && finalSearch.length) {
      setVisibleData(
        coursesData.filter((course) => finalSearch.includes(course.title))
      );
      dispatch(setCourseView(0));
    }
    // eslint-disable-next-line
  }, [finalSearch]);

  useEffect(() => {
    if (advancedSearch.length) {
      let filteredResult = [];
      advancedSearch.forEach((param) => {
        if (param[1].length > 0) {
          if (param[0] === "Keywords") {
            let searchKeywords = param[1].split(",");
            searchKeywords = searchKeywords.map((word) => word.toLowerCase());
            coursesData.forEach((course) => {
              let courseKeywords = course.keywords.split(",");
              for (let keyword of courseKeywords) {
                if (searchKeywords.includes(keyword.toLowerCase())) {
                  filteredResult.push(course);
                  break;
                }
              }
            });
          } else {
            if (filteredResult.length) {
              filteredResult = filteredResult.filter(
                (course) =>
                  course.topics_count.toString() === param[1].toString()
              );
            } else {
              filteredResult = coursesData.filter(
                (course) =>
                  course.topics_count.toString() === param[1].toString()
              );
            }
          }
        }
      });
      if (filteredResult.length) {
        setVisibleData(filteredResult);
      }
    }
    // eslint-disable-next-line
  }, [advancedSearch]);

  const loadMoreHandler = () => {
    setVisibleData(coursesData.slice(0, visibleData.length + 10));
    if (visibleData.length + 10 >= coursesData.length) {
      setLoadMoreVisible(false);
    }
  };

  return (
    <Box
      d="flex"
      justifyContent="flex-start"
      alignItems="center"
      flexDirection="column"
      minH="90vh"
      pl={[
        "0",
        "0",
        "0",
        slider ? (window.innerWidth < 1400 ? "18vw" : "13vw") : "7.5vw",
      ]}
      transition="all 350ms ease"
    >
      <Box
        width={["95%", "95%", "95%", "80%"]}
        justifyContent="space-between"
        alignItems="center"
        d="flex"
        mb="2rem"
      >
        <Text
          fontSize={["20px", "25px", "30px", "40px"]}
          d={["none", "none", "none", "flex"]}
          fontWeight="900"
          style={{ fontFamily: "Mulish, sans-serif" }}
        >
          {headerText}
        </Text>
        {!isLoading && coursesData.length > 0 && (
          <SearchComponent notShowAdvSearch />
        )}
      </Box>

      {isLoading ? (
        <Progress isIndeterminate size="xs" width="80%" />
      ) : !isLoading && coursesData.length === 0 ? (
        <EmptyComponentTemplate
          name="Items"
          ComponentIcon={CoursesIcon}
          bgColor="#fd5f3a"
          hoverColor="#e35533"
          redirectAddress="/courses/add-items"
          method={loadCourses}
        />
      ) : (
        <Box width="100%" alignItems="center" d="flex" flexDirection="column">
          {/* <Box width={['95%', '95%', '95%', '80%']} justifyContent='flex-end' alignItems='center' d='flex' mb='2rem'>
                                <ButtonGroup size="md" isAttached variant="outline" borderRadius='12px' bg='#ffffff'>
                                    <IconButton
                                        bg={currentView === 0 ? '#fd5f3a' : 'transparent'}
                                        _hover={{ bg: currentView === 0 ? '#e35533' : '#f3f3f3' }}
                                        padding='1' aria-label="List View"
                                        onClick={() => dispatch(setCourseView(0))}
                                        icon={<ListView width='24px' height='24px' fill={currentView === 0 ? '#ffffff' : '#93a2ba'} />}
                                    />
                                    <IconButton
                                        bg={currentView === 1 ? '#fd5f3a' : 'transparent'}
                                        _hover={{ bg: currentView === 1 ? '#e35533' : '#f3f3f3' }}
                                        padding='1' aria-label="Calendar View"
                                        onClick={() => dispatch(setCourseView(1))}
                                        icon={<CalendarView fill={currentView === 1 ? '#ffffff' : '#93a2ba'} width='24px' height='24px' />}
                                    />
                                </ButtonGroup>
                            </Box> */}
          {currentView === 0 ? (
            <>
              <AllCourses
                courses={visibleData}
                method={loadMoreHandler}
                loadMoreVisible={loadMoreVisible}
              />
              <MobileAllCourses
                courses={visibleData}
                method={loadMoreHandler}
                loadMoreVisible={loadMoreVisible}
              />
            </>
          ) : (
            <Box
              width={["95%", "95%", "95%", "80%"]}
              justifyContent="flex-end"
              alignItems="center"
              d="flex"
              mb="2rem"
            >
              <CourseCalendar courses={coursesData} />
            </Box>
          )}
        </Box>
      )}

      {/* {
                !isLoading && coursesError && <Box>{coursesError}</Box>
            } */}

      <AlertMessage
        isOpen={alertOpen}
        onClose={onAlertClose}
        text={"ERROR!"}
        message={"Course Cannot be Deleted!\n\nContact Administrator!"}
      />
    </Box>
  );
}
